import React from 'react';
import { DateInput } from 'components';
import moment from 'moment-timezone';
/*
 * If I can delete this file
 * No specific code for the client left
 */

export const LuccaSpecialConf = {
  orgId: '52087c71-4990-40eb-8fa8-b1b3fd343a71',
  panelId: 'b1ef2f70-4d9e-4e87-ab69-812b7faeaa93',
  specialFields: [
    {
      name: '__luccaDateItw',
      participantLabel: 'Date itw',
      clientLabel: 'Date itw',
      formComponent: DateInput,
      accessor: (p: any) =>
        p.__luccaDateItw ? moment(p.__luccaDateItw).format('L') : null,
    },
    {
      name: '__luccaLastInteraction',
      participantLabel: 'Dernier échange',
      clientLabel: 'Dernier échange',
      formComponent: DateInput,
      accessor: (p: any) =>
        p.__luccaLastInteraction
          ? moment(p.__luccaLastInteraction).format('L')
          : null,
    },
  ],
};
